import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Lock, Loader2, ArrowRight, CheckCircle2, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { AuthScene, AuthCard, AuthInput } from "@/pages/Login";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { resetPassword } = useAuth();
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (next.length < 8) return setErr("Password must be at least 8 characters.");
    if (next !== confirm) return setErr("Passwords don't match.");
    setBusy(true);
    try {
      await resetPassword(token, next);
      setDone(true);
      setTimeout(() => navigate("/login", { replace: true }), 1800);
    } catch (e2) {
      const d = e2?.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Reset link is invalid or expired.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthScene>
      <div className="fh-eyebrow" style={{ color: "#FFE066" }}>
        Reset password
      </div>
      <h1 className="fh-heading" style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }}>
        Choose a new password
      </h1>
      <AuthCard>
        {done ? (
          <div className="text-white/90 text-sm" data-testid="reset-done">
            <CheckCircle2 className="h-5 w-5 text-amber-300 inline mr-2" />
            Password updated. Redirecting to sign-in…
          </div>
        ) : (
          <form onSubmit={submit}>
            <AuthInput
              label="New password"
              type="password"
              value={next}
              onChange={setNext}
              icon={<Lock className="h-4 w-4" />}
              testId="reset-new"
              autoFocus
              autoComplete="new-password"
            />
            <AuthInput
              label="Confirm new password"
              type="password"
              value={confirm}
              onChange={setConfirm}
              icon={<Lock className="h-4 w-4" />}
              testId="reset-confirm"
              autoComplete="new-password"
            />
            {err ? <div className="text-sm text-red-300 mb-3" data-testid="reset-error">{err}</div> : null}
            <button type="submit" disabled={busy} className="fh-btn-primary w-full" data-testid="reset-submit">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ArrowRight className="h-4 w-4" />}
              {busy ? "Saving…" : "Save new password"}
            </button>
            <div className="mt-4 text-xs">
              <Link to="/login" className="text-white/70 hover:text-amber-300 underline-offset-4 hover:underline">
                <ArrowLeft className="h-3.5 w-3.5 inline mr-1" /> Back to sign in
              </Link>
            </div>
          </form>
        )}
      </AuthCard>
    </AuthScene>
  );
}
